var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Translate } from "../../../../../I18N";
import { TableHeader } from "../components/TableHeader";

// in case there will be aesthetic changes to the table header,
//  we can change the component here but its probably an overkill now
const generateTableHeader =
(
translationKey,
options) =>



() => /*#__PURE__*/
_jsx(TableHeader, { className: options === null || options === void 0 ? void 0 : options.className }, void 0,
translationKey && /*#__PURE__*/_jsx(Translate, {}, void 0, translationKey)
);


export { generateTableHeader };